/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Templates_No_Templates_FoundInputs */

const en_event_templates_no_templates_found = /** @type {(inputs: Event_Templates_No_Templates_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Event Templates Found`)
};

const fr_event_templates_no_templates_found = /** @type {(inputs: Event_Templates_No_Templates_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun modele d'evenement trouve`)
};

const de_event_templates_no_templates_found = /** @type {(inputs: Event_Templates_No_Templates_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Ereignisvorlagen gefunden`)
};

const it_event_templates_no_templates_found = /** @type {(inputs: Event_Templates_No_Templates_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun modello di evento trovato`)
};

const ru_event_templates_no_templates_found = /** @type {(inputs: Event_Templates_No_Templates_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шаблоны мероприятий не найдены`)
};

const es_event_templates_no_templates_found = /** @type {(inputs: Event_Templates_No_Templates_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron plantillas de eventos`)
};

const zh_cn2_event_templates_no_templates_found = /** @type {(inputs: Event_Templates_No_Templates_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到活动模板`)
};

const ja_event_templates_no_templates_found = /** @type {(inputs: Event_Templates_No_Templates_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントテンプレートが見つかりません`)
};

const hi_event_templates_no_templates_found = /** @type {(inputs: Event_Templates_No_Templates_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई इवेंट टेम्प्लेट नहीं मिला`)
};

const pt_pt2_event_templates_no_templates_found = /** @type {(inputs: Event_Templates_No_Templates_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum modelo de evento encontrado`)
};

/**
* | output |
* | --- |
* | "No Event Templates Found" |
*
* @param {Event_Templates_No_Templates_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_templates_no_templates_found = /** @type {((inputs?: Event_Templates_No_Templates_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Templates_No_Templates_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_templates_no_templates_found(inputs)
	if (locale === "de") return de_event_templates_no_templates_found(inputs)
	if (locale === "it") return it_event_templates_no_templates_found(inputs)
	if (locale === "ru") return ru_event_templates_no_templates_found(inputs)
	if (locale === "es") return es_event_templates_no_templates_found(inputs)
	if (locale === "zh-CN") return zh_cn2_event_templates_no_templates_found(inputs)
	if (locale === "ja") return ja_event_templates_no_templates_found(inputs)
	if (locale === "hi") return hi_event_templates_no_templates_found(inputs)
	if (locale === "pt-PT") return pt_pt2_event_templates_no_templates_found(inputs)
	return en_event_templates_no_templates_found(inputs)
});